'use client';

import { faClipboard, faCreditCard, faUserPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { DetailsCard } from '@/components/molecules/DetailsCard';
import { RegistrationDetailsSkeleton } from '@/components/molecules/skeletons/RegistrationDetailsSkeleton';
import { currencyFormats } from '@/entities/CurrencyFormat';
import { useCurrenciesQuery } from '@/hooks/lookups/useCurrencyQuery';
import { useTeamLeagueDetailsQuery } from '@/hooks/team-leagues/useDetailsQuery';
import { useSeasonInfoQuery } from '@/hooks/teamLeagueSeasonInfo/useSeasoninfoQuery';
import { determinePriceDisplay } from '@/utils/utils';

interface SeasonRegistrationDetailsProps {
	teamLeagueId: string;
}

export const SeasonRegistrationDetails = ({ teamLeagueId }: SeasonRegistrationDetailsProps) => {
	const { data: seasonInfo, isFetching: isFetchingSeason } = useSeasonInfoQuery(teamLeagueId);
	const { data: leagueInfo, isFetching: isFetchingLeagueInfo } = useTeamLeagueDetailsQuery(teamLeagueId);
	// condition Boolean(seasonInfo?.data && leagueInfo?.data) added becuase useCurrenciesQuery was loading indefinetly
	const { data: currencies, isFetching: isFetchingCurrecnies } = useCurrenciesQuery(Boolean(seasonInfo?.data && leagueInfo?.data));
	const currency = currencies?.data?.find((currency) => currency.id === leagueInfo?.data?.currencyId.toString());

	const isFetching = isFetchingSeason || isFetchingLeagueInfo || isFetchingCurrecnies;

	return (
		<>
			{isFetching && <RegistrationDetailsSkeleton />}
			{!isFetching && (
				<div>
					<DetailsCard
						title="Registrations"
						content={
							<div>
								<p className="flex pt-4">
									<FontAwesomeIcon icon={faClipboard} className="size-6 pr-4" />
									Divisions ({seasonInfo?.data?.divisionsCount})
								</p>
								<p className="flex pt-4">
									<FontAwesomeIcon icon={faUserPlus} className="size-6 pr-4" />
									{seasonInfo?.data?.playerCount} players registered
								</p>
								{seasonInfo?.data?.cost && (
									<p className="flex pt-4">
										<FontAwesomeIcon icon={faCreditCard} className={'size-6 pr-4'} />
										<span className="font-medium text-gray-700">
											{determinePriceDisplay(seasonInfo?.data?.cost, currencyFormats[currency?.abbreviation || 'USD'])}
										</span>
									</p>
								)}
							</div>
						}
					/>
				</div>
			)}
		</>
	);
};
